import { makeStyles } from '@material-ui/core';

export const rescisaoStyles = makeStyles({
  container: {
    justifyContent: 'center',
    marginTop: '3%',
    maxHeight: '75%',
  },
  paperClass: {
    maxWidth: '700px',
  },
});
